<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">短信库</a></li>
                <li>邮件</li>
                <li><a href="#">增加短信</a></li>
            </ul>
        </div>    
        <div class="formbody">
            <ul class="forminfo mt20" v-show="isShow">
                <li><label>短信内容 </label>
                    <textarea name="" v-model="content" cols="" rows="" class="textinput left maringht10"></textarea> 
                    <input name="" type="button" @click="addSmsContent()" class="scbtn" style="width:150px;" value="增加短信库类型"/>
                </li>
            </ul>

            <table class="tablelist" style="width: 80%;margin: 0px auto;">
                <thead>
                    <tr>
                    <th style="text-align:center"><font color="#FF0000">{{typename}}</font>库中的 短信内容</th>
                    </tr>
                </thead>
                <tbody>            
                    <tr v-for="item in smsClassFiyContentList">
                        <td>{{item.content}}</td>
                    </tr>    
                </tbody>
            </table>
            <div class="jian">&nbsp;</div>
        </div> 
        <div class="tip">
            <div class="tiptop"><span>提示信息</span><a></a></div>
        
            <div class="tipinfo">
                <span><img src="images/ticon.png" /></span>
                <div class="tipright">
                    <p>是否确认对信息的修改 ？</p>
                    <cite>如果是请点击确定按钮 ，否则请点取消。</cite>
                </div>
            </div>
        
            <div class="tipbtn">
                <input name="" type="button"  class="sure" value="确定" />&nbsp;
                <input name="" type="button"  class="cancel" value="取消" />
            </div>
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            smsClassFiyContentList:[],
            id:this.$route.query.id,
            typename:this.$route.query.typename,
            isShow:this.$route.query.e==1?true:false,
            content:'',
        }
    },
    mounted(){
        this.getData();
    },
    methods:{
        getData(){
            let that = this;
            let data = {'id':this.id};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/getsmsclassfiycontent.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.smsClassFiyContentList = res.data.smsContentList;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        addSmsContent(){
            if(this.content.trim() == ''){
                alert("短信内容不能为空！");
                return;
            }
            let that = this;
            let data = {'typeid':this.id,'content':this.content};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/insertsmsclassfiycontent.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("新增短信内容成功！");
                    that.getData();
                    that.content = '';
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/sms/smsclassfiycontent.vue